import { types, Instance } from "mobx-state-tree";

export const File = types.model({
    description: types.string,
    file: types.string,
});

export interface IFile
  extends Instance<typeof File> {}